import { ControlPointDuplicate } from '@mui/icons-material';
import { Button } from '@mui/material';

interface IProps {
  onClick: () => void;
  disabled?: boolean;
}

const DuplicateButton = ({ onClick, disabled = false }: IProps) => {
  return (
    <Button
      variant='outlined'
      sx={{
        height: '32px',
        borderRadius: '50px',
        border: '1px solid #C4D0CB',
        padding: '6px 12px',
      }}
      color='primary'
      startIcon={<ControlPointDuplicate />}
      onClick={onClick}
      disabled={disabled}
    >
      Duplicate
    </Button>
  );
};

export default DuplicateButton;
